export default {
  getCotacoes(state) {
    return state.cotacoes;
  },
  getCotacao(state) {
    return state.cotacao;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getCampos(state) {
    return state.campos;
  },
  getColDefault(state) {
    return state.colDefault;
  },
  getDirectionDefault(state) {
    return state.directionDefault;
  },
  getColunasItensSimulacao(state) {
    return state.colunasItensSimulacao;
  },
  getRegimesApuracao(state) {
    return state.regimesApuracao;
  },
  getPortos(state) {
    return state.portos;
  },
  getColunasItensRealizarSimulacao(state) {
    return state.colunasItensRealizarSimulacao;
  },
  getColunasItensRealizarSimulacaoContaOrdem(state) {
    return state.colunasItensRealizarSimulacaoContaOrdem;
  },
  getColunasItensInvoice(state) {
    return state.colunasItensInvoice;
  },
  getIncoterms(state) {
    return state.incoterms;
  },
  getAplicacoesProdutos(state) {
    return state.aplicacoesProdutos;
  },
  getClassificacoes(state) {
    return state.classificacoes;
  },
  getCategorias(state) {
    return state.categorias;
  },
  getModalidades(state) {
    return state.modalidades;
  },
  getModalidadesRateio(state) {
    return state.modalidadesRateio;
  },
  getFiliaisBeneficios(state) {
    return state.filiaisBeneficios;
  },
  getOpcoesLogisticaNacional(state) {
    return state.opcoesLogisticaNacional;
  },
  getOpcoesAcondicionamentoCarga(state) {
    return state.opcoesAcondicionamentoCarga;
  },
  getOpcoesICMS(state) {
    return state.opcoesICMS;
  },
  getOpcoesIcmsContaOrdem(state) {
    return state.opcoesIcmsContaOrdem;
  },
  getOpcoesFclLcl(state) {
    return state.opcoesFclLcl;
  },
  getOpcoesCargaPerigosa(state) {
    return state.opcoesCargaPerigosa;
  },
  getOpcoesMoeda(state) {
    return state.opcoesMoeda;
  },
  getColunasImpostos(state) {
    return state.colunasImpostos;
  },
  getOpcoesAnuenciaLI(state) {
    return state.opcoesAnuenciaLI;
  },
  getOpcoesColetaPorto(state) {
    return state.opcoesTabelaColetaPorto;
  },
  getSalarioMinimo(state) {
    return state.salarioMinimo;
  },
  getValorBaseDespesasAdministrativas(state) {
    return state.valorBaseDespesasAdministrativas;
  },
  getOpcoesSeguroInternacional(state) {
    return state.opcoesSeguroInternacional;
  },
  getOpcoesMajoracaoCofins(state) {
    return state.opcoesMajoracaoCofins;
  },
  getInvoicesFormatadas(state) {
    // eslint-disable-next-line arrow-body-style
    const invoices = state.invoices.map((invoice) => {
      return {
        text: `${invoice.referenciaTrust} - ${invoice.produto ? invoice.produto : ''}`,
        ...invoice,
      };
    });

    return invoices;
  },
  getUnidadesMedida(state) {
    return state.unidadesMedida;
  },
};
